import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { BasicDropdownProps } from "../../../../types/UiKits";
import DropdownCommon from "./DropdownCommon";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const BasicDropdown: React.FC<BasicDropdownProps> = ({ title, span, colClass, bodyClass, data, toggleClass }) => {
  return (
    <Col className={colClass}>
      <Card>
        <CommonCardHeader title={title} span={span} />
        <CardBody className={bodyClass ? bodyClass : "rtl-dropdown"}>
          <div className="common-flex">
            {data &&
              data.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} toggleClass={toggleClass} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicDropdown;
